define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.slice;
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706121922-6a92b31330-master/~/jquery/src/var/slice.js
// module id = 204
// module chunks = 1